import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import { formatDate, myId } from '../../lib/MyLibrary';

const ShowDataDB = ({data, myFontSize}) => {
  const [dataClient, setDataClient] = useState([]);
  useEffect(() => {
    //console.log('data.data.result:..',data.data.result);
    /* const tempArray = Object.entries(data.data.result);
    const dataArray = tempArray.filter((item)=>item[0]!=='_id'&&item[0]!=='__v');
    //console.log('dataArrayDB:..',dataArray);
    if (dataArray) setDataClient(dataArray); */
    const tempData = {...data.data.result};
    if(tempData){
      const tempArray = [
        [ 'idAptos:', tempData.idAptos||'null'],
        [ 'email:', tempData.email||'null'],
        [ 'Nombre:', tempData.nameUser||'null'],
        [ 'Apellido Paterno:', tempData.paterno||'null'],
        [ 'Apellido Materno:', tempData.materno||'null'],
        [ 'Fecha de Nacimiento:', formatDate(new Date(tempData.userFenac))||'null'],
        [ 'Género:', tempData.gender||'null'],
        [ 'Estado Civil:', tempData.maritalStatus||'null'],
        [ 'Código Postal:', tempData.zipCode||'00000'],
        ['Teléfono:', tempData.phoneUser||'null'],
        [ 'Ciudad:', tempData.cityUser||'cityUser'],
        [ 'Intereses:', tempData.userPreferences.join(' ')||'none'],
        [ 'Fecha de Creación:', tempData.createdDate||'null'],
        [ 'Cupón:', tempData.cuponCode||'null'],
        [ 'Tipo de Cupón:', tempData.cuponType||'null'],
        [ 'Vigencia:', tempData.cuponVigencia||'null'],
        [ 'Newsletter:', String(tempData.newsLetter)||'null'],
        [ 'Aviso de Privacidad:', String(tempData.privacy)||'null'],
        [ 'Términos y Condiciones:', String(tempData.tyc)||'null'],
        [ 'Status:', tempData.estatus||'null'],
        [ 'Creado en:', tempData.userEnv||'null']
      ]
      setDataClient(tempArray);
    }else setDataClient(null);
    
    return 
  }, [])
  
  return (
    <div>
      <Container fluid style={{width: "90%"}} className='border borde-2 bg-light p-3 rounded'>
      {dataClient && 
        <div>
        {dataClient?.map((item)=> {
      
          return <p key={myId()} style={{ width: "90%" }} className="text-secondary fs-6 my-0 ms-auto me-auto">
          <span style={{ width: "40%", fontSize: myFontSize }} className="border border-2 d-inline-block ps-2 pt-1">{item[0]}</span>
          <span style={{ width: "60%", fontSize: myFontSize }} className="border border-2 text-danger d-inline-block ps-2 pt-1">{item[1]}</span>
        </p>
        
      })}
      </div>
    }
      </Container>
    </div>
  )
}

export default ShowDataDB